module.exports = __webpack_public_path__ + "img/zu3.20d4dd69.png";